import { checkCookieConsent, initializeGTM } from './gtm';
import { initializeMixpanel } from './mixpanel';
initializeGTM();
checkCookieConsent();
initializeMixpanel();
